import { Card, CardProps } from "react-bootstrap";
import styled from "styled-components";

interface Props extends CardProps {
  backgroundColor?: string;
}

export const CardStyled = styled(Card)<Props>`
  border-radius: 12px;
  ${({ backgroundColor }) =>
    backgroundColor && `background-color: ${backgroundColor}`};
  border: none;

  .card-header {
    border: none;
    border-radius: 12px 12px 12px 12px;
  }
`;
